import {ReviewSummaryGI} from '../../common/types';

export interface HotelDetailsFromStatic {
  foodAndDining?: FoodDiningShape;
  foodDining?: FoodDiningAltAcco;
  mapImageUrl: string;
  amenitiesGI?: AmenitiesGI;
  govtPolicies?: GovtPolicy[];
  hostInfoV2: HostInfoShape;
  coupleFriendlyPersuasion: CoupleFriendlyPersuasion;
  supressHouseRules: boolean;
  address: Address;
  checkinTime: string;
  checkoutTime: string;
  checkinTimeRange: string;
  checkoutTimeRange: string;
  id: string;
  ingoId: string;
  name: string;
  showCallToBook: boolean;
  locationDetail: LocationDetail;
  starRating: number;
  categories: string[];
  pinCode: string;
  propertyType: string;
  propertyLabel: string;
  freeWifi: boolean;
  hotelIcon: string;
  primaryArea: string;
  shortDesc: string;
  longDesc: string;
  entireProperty: boolean;
  secrecyOption: boolean;
  hotelVideos: HotelVideos;
  houseRules: HouseRules;
  stayType: string;
  altAcco: boolean;
  lat: number;
  lng: number;
  highlightedAmenities: string[];
  longStayAmenities: any[]; // Consider creating a specific interface if structure is known
  locationPersuasion: string[];
  sharingUrl: string;
  detailDeeplinkUrl: string;
  contextType: string;
  context: string;
  alternateDatesAvailable: boolean;
  mmtHotelCategory: string;
  groupBookingQueryEnabled: boolean;
  houseRulesV2: HouseRulesV2;
  groupBookingHotel: boolean;
  calendarCriteria: CalendarCriteria;
  specialFare: boolean;
  goStay: boolean;
  premiumUsp: PremiumUsp;
  isWishListed: boolean;
  flexibleCheckin: FlexibleCheckin;
  flexibleCheckinInfo: FlexibleCheckinInfo;
  giPrivateSpacesV2: object[];
  giSharedSpacesV2: object[];
  propertyLayoutTitleText: string;
  mediaV2: any;
  faqData: FaqData;
}

export interface FaqData {
  extraItemText: string;
  hint: string;
  title: string;
  faqs: {
    answer: string;
    question: string;
  }[];
}

export type FlexibleCheckin = {
  rules: string[];
};

export interface FlexibleCheckinInfo {
  title: string;
  subTitle: string;
  defaultSlotMsg: string;
  timeSlots: TimeSlot[];
  tagUrl: string;
}

export interface TimeSlot {
  id: string;
  value: string;
}

export interface Address {
  line1: string;
  line2: string;
}

export interface HouseRules {
  commonRules: CommonRule[];
  childExtraBedPolicy: ExtraBedPolicy;
  extraBedPolicyList: ExtraBedPolicy[];
  contextRules: ContextRule[];
  mustReadRules: MustReadRule[];
}

export interface HouseRulesV2 {
  tag: boolean;
  contextRules: ContextRule[];
  allRules: CommonRule[];
}

export interface CommonRule {
  category: string;
  id: string;
  showInHost: boolean;
  rules: Rule[];
  showInDetailHome: boolean;
  expandRules: boolean;
  categoryId?: number;
}

export interface Rule {
  text: string;
  required?: boolean;
  values?: string[];
}

export interface ExtraBedPolicy {
  policyInfo: string;
  policyRules: PolicyRule[];
  label: string;
  id: string;
  paid: boolean;
}

export interface PolicyRule {
  extraBedTerms: ExtraBedTerm[];
}

export interface ExtraBedTerm {
  value: string;
}

export interface ContextRule {
  category: string;
  title: string;
  desc: string;
  tag: string;
  ruleIcon: string;
}

export interface MustReadRule {
  category: string;
  id: string;
  showInHost: boolean;
  rules: Rule[];
  showInDetailHome: boolean;
  expandRules: boolean;
}

export interface AmenitiesGI {
  categorized: CategorizedAmenity[];
  transformed: TransformedAmenity[];
  rated: RatedAmenity[];
  unrated: UnratedAmenity[];
}

export interface CategorizedAmenity {
  label: string;
  data: string[];
}

export interface TransformedAmenity {
  code: string;
  name: string;
}

export interface RatedAmenity {
  code: string;
  name: string;
  rating: number;
  maxRating: number;
  persuasion: string;
}

export interface UnratedAmenity {
  code?: string;
  name: string;
}

export interface CoupleFriendlyPersuasion {
  iconName: string;
  persuasionText: string;
  hoverData: HoverData;
  colourCodeData: ColourCodeDataFromStatic;
  persuasionId: string;
  persuasionFilter: PersuasionFilter;
}

export interface HoverData {
  iconName: string;
  heading: string;
  hoverTextList: string[];
  filterText: string;
  headingColour: TextBackgroundColour;
  hoverColour: TextBackgroundColour;
  filterTextColour: string;
}

export interface TextBackgroundColour {
  textColour: string;
  backgroundColour: string;
}

export interface ColourCodeDataFromStatic {
  textColour: string;
  backgroundColour: string;
}

export interface PersuasionFilter {
  tag: string;
  filterRequest: boolean;
  dayUseRequest: boolean;
}

export interface PremiumUsp {
  summary: string;
  highlights: Highlight[];
}

export interface Highlight {
  key: string;
  iconUrl: string;
  heading: string;
  description: string;
}

export interface ImageGalleryItem {
  src: string;
  type: string;
  giTag: string;
  small: string;
  medium: string;
  big: string;
}

export interface ImageGallery {
  galleryExpThree: ImageGalleryItem[];
  propertyImageCount: number;
  travellerImageCount: number;
}

export interface MediaFromStatic {
  imageGallery: ImageGallery;
}

export interface VideoMedia {
  videoUrl: string;
  thumbnailUrl: string;
  processedVideos: {
    snapshotUrl: string;
  };
  id: string;
  type: string;
  // other properties based on usage
}

export interface HotelVideos {
  videoMedia: VideoMedia[];
  // other properties based on usage
}

export interface FdElementType {
  rti: number;
  grpil: Array<number>;
}
export interface RfElementType {
  name: string;
  ic: string;
  fd: Array<FdElementType>;
  fc: string;
}
export interface SpaceDataGalleryItem {
  src: string;
  type: string;
  giTag: string;
  small: string;
  medium: string;
  big: string;
  showTagName: boolean;
}
export interface FoodDiningSpaceData {
  name: string;
  type: string;
  subtitle: string;
  ugc: object;
  gallery: SpaceDataGalleryItem[];
  details: {
    persuasion?: {
      icon: string;
      text: string;
      details: {
        val: string;
      };
    };
    timings?: {
      icon: string;
      text: string;
      details: {mealType: string; start: string; end: string}[];
    };
    avgMealCost?: {
      icon: string;
      text: string;
      details: {
        pax: string;
        curr: string;
        val: number;
      };
    };
    cuisines?: {
      icon: string;
      text: string;
      details: {
        val: string[];
      };
    };
  };
  offers: PersuationOfferItem[];
}
export interface PersuationOfferItem {
  icon: string;
  text: string;
  details: {
    val: string[];
  };
}
export interface PropertyRulesItem {
  icon: string;
  text: string;
  details: object;
}

export interface PolicyData {
  tid: string;
  catg: string;
  l_txt: string;
  s_txt: string;
  header: string;
  resp_type: string;
  resp: {
    text: string;
  };
  sentiment: string;
}

export interface GovtPolicy {
  header: string;
  data: PolicyData[];
}

export interface FoodDiningRule {
  category: string;
  id: string;
  showInHost: boolean;
  rules: {
    text: string;
  }[];
  showInDetailHome: boolean;
  expandRules: boolean;
  description?: string;
  images?: string[];
}

export interface FoodDiningAltAcco {
  title: string;
  tag: boolean;
  allRules: FoodDiningRule[];
}

export interface FoodDiningShape {
  hasRestaurant: boolean;
  hasKitchen: boolean;
  ambienceRating: number;
  roomServiceText: string;
  tasteRating: number;
  propertyRules: {
    allowed: PropertyRulesItem[];
    notAllowed: PropertyRulesItem[];
  };
  restaurants: FoodDiningSpaceData[];
}

export type HostInfoShape = {
  name: string;
  about: string;
  timeSinceHostingOnMmt: string;
  hostImage: string;
  responseTime: string;
  language: string;
  chatEnabled: boolean;
  caretakerAvailability: string;
  caretakerResponsibilities: string[];
};

// Food Dining Types
export enum FoodTagType {
  Food = 'Food',
  FoodMenu = 'Food Menu',
  BarMenu = 'Bar Menu',
  Restaurant = 'Restaurant/cafe',
  Dining = 'Dining',
}

export enum SoldOutOrderKeys {
  AlternateDates = 'alt-date',
  SimilarProperties = 'similar-prop',
}

export interface PlacesResponse {
  categories: Category[];
}

export interface Category {
  priority: number;
  category_type: string;
  category_data: Place[];
}

export interface Place {
  distanceUnit: string;
  seoUrl: string;
  voyId: string;
  location: Location;
  place_name: string;
  place_id: string;
  category: string;
  distance: string;
}

export interface Location {
  lat: string;
  lon: string;
}

export interface RoomInfoFromStatic {
  roomName: string;
  roomCode: string;
  maxGuest: number;
  maxAdult: number;
  maxChild: number;
  parentRoomCode: string;
  master: boolean;
  bedCount: number;
  maxGuestCount: number;
  maxAdultCount: number;
  maxChildCount: number;
  roomSize?: string;
  roomViewName?: string;
  bedroomCount?: number;
  beds?: BedFromStatic[];
  images?: string[];
  amenities?: AmenityFromStatic[];
}

export interface BedFromStatic {
  type: string;
  count: number;
  bedTypeKey: string | null;
}

export interface AmenityFromStatic {
  name: string;
  facilities: Facility[];
}

export interface Facility {
  name: string;
  type: string;
  sequence: number;
  categoryName: string;
  attributeName: string;
  highlightedName: string;
  displayType?: string;
  childAttributes?: ChildAttribute[];
  tags?: string[];
}

export interface ChildAttribute {
  name: string;
  subAttributes: any[];
}

export interface RoomInfoMap {
  [roomCode: string]: RoomInfoFromStatic;
}

export interface WeaverResponse {
  success: boolean;
  data: {
    rendering_slot: string;
    summary_view: {
      template: string;
      data: {
        title: string;
        headline: string;
        highlights: string[];
        layers: {
          id: string;
          title: {
            text: string;
            color: string;
          };
          main_block: {
            bgcolor: string;
            border_color: string;
          };
          icon: {
            url: string;
          };
        }[];
      };
    };
    detail_view: {
      template: string;
      data: {
        title: string;
        img: string;
        headline: string;
        layers: {
          [key: string]: {
            title: string;
            layout: string;
            data: {
              type: string;
              data:
                | string
                | {
                    type: string;
                    data: string;
                  }[];
            }[][];
          };
        };
        layers_rank: string[];
      };
    };
    flags: any[];
  };
}

// Root interface for the entire response
export interface HotelCompareResponse {
  hotelList: SimilarHotelShape[];
  rankingAlgo: string;
}

// Interface for individual hotel entries
export interface SimilarHotelShape {
  id: string;
  giId: string;
  name: string;
  propertyType: string;
  propertyLabel: string;
  stayType: string;
  starRating: number;
  soldOut: boolean;
  showCallToBook: boolean;
  groupBookingHotel: boolean;
  groupBookingPrice: boolean;
  maskedPrice: boolean;
  isGroupBookingForSimilar: boolean;
  alternateDates: boolean;
  multiRoomRecommendation: boolean;
  isAltAcco: boolean;
  mtKey: string;
  totalImageCount: number;
  travellerImageCount: number;
  categories: string[];
  locationPersuasion: string[];
  media: SimilarHotelMedia[];
  priceDetail: PriceDetailFromStatic;
  hotelPersuasions: {[key: string]: Persuasion};
  locationDetail: LocationDetail;
  geoLocation: GeoLocation;
  freeCancellationText: string;
  shortList: boolean;
  totalRoomCount: number;
  sponsored: boolean;
  newType: boolean;
  heroImage: string;
  appDeeplink: string;
  calendarCriteria: CalendarCriteria;
  similarHotelsRequired: boolean;
  facilitiesConfigMap: {[key: string]: string};
  roomName: string;
  reviewSummaryUgc: ReviewSummaryUgc;
  facilityHighlights: string[];
  myBizAssured: boolean;
  perNightTitle: string;
  lovedByIndians: boolean;
  isWishListed: boolean;
  hotelImage: string;
  amenitiesList: string[];
}

// Interface for media items
export interface SimilarHotelMedia {
  url: string;
  mediaType: string;
}

// Interface for price details
export interface PriceDetailFromStatic {
  price: number;
  priceWithTax: number;
  discountedPrice: number;
  discountedPriceWithTax: number;
  totalTax: number;
  emiDetails: EmiDetails;
  coupon: CouponFromStatic;
  pricingKey: string;
  myPartnerDiscount: number;
  groupPriceText: string;
  priceSuffix: string;
  taxesAndFeesText: string;
}

// Interface for EMI details
export interface EmiDetails {
  type: string;
  tenure: number;
  totalInterest: number;
  bankName: string;
  amount: number;
  totalCost: number;
}

// Interface for coupon information
export interface CouponFromStatic {
  code: string;
  description: string;
  specialPromo: boolean;
  type: string;
  couponAmount: number;
  autoApplicable: boolean;
  bnplAllowed: boolean;
  disabled: boolean;
  bankOffer: boolean;
}

// Interface for hotel persuasions
export interface Persuasion {
  template: string;
  data: PersuasionData[];
  placeholder: string;
}

// Interface for persuasion data
export interface PersuasionData {
  hasAction: boolean;
  actionType: string;
  persuasionType: string;
  html: boolean;
  style: PersuasionStyle;
  id: string;
  text: string;
}

// Interface for style classes
export interface PersuasionStyle {
  styleClasses: string[];
}

// Interface for location details
export interface LocationDetail {
  id: string;
  name: string;
  type: string;
  countryId: string;
  countryName: string;
}

// Interface for geographical location
export interface GeoLocation {
  latitude: number;
  longitude: number;
}

// Interface for calendar criteria
export interface CalendarCriteria {
  available: boolean;
  maxDate: string;
  advanceDays: number;
  mlos: number;
}

// Interface for user-generated content summary
export interface ReviewSummaryUgc {
  filteredReviewCount: FilteredReviewCount;
  hotelRating: number;
  reviewCount: number;
  ratingCount: number;
  ota: string;
  topicRatings: TopicRating[];
}

// Interface for filtered review count
export interface FilteredReviewCount {
  image: number;
  negative: number;
  featured: number;
  posWithContent: number;
  experiencedTraveller: number;
  positive: number;
  negWithContent: number;
}

// Interface for topic ratings
export interface TopicRating {
  rating: number;
  title: string;
}

export interface CardInfo {
  subType: string;
  // other properties based on usage
}

export interface LOVEDBYGUEST {
  cardInfo: CardInfo;
  // other properties based on usage
}

export interface CardData {
  LOVEDBYGUEST: LOVEDBYGUEST;
  // other properties based on usage
}

export interface DetailPersuasionCards {
  cardData: CardData;
}

export interface StaticResp {
  hotelDetails: HotelDetailsFromStatic;
  placesResponse: PlacesResponse;
  media: MediaFromStatic;
  roomInfoMap: RoomInfoMap;
  uuids: string[];
  weaverResponse: WeaverResponse;
  reviewSummaryGI: ReviewSummaryGI;
  widget_display_order: SoldOutOrderKeys;
  hotelCompareResponse: HotelCompareResponse;
  detailPersuasionCards: DetailPersuasionCards;
  ugcSummary: UgcSummary;
  amenitiesGI?: AmenitiesGI;
}

export interface UgcSummary {
  best: Review[];
  availableOTAs: string[];
  source: string;
  cumulativeRating: number;
  reviewCount: number;
  ratingCount: number;
  recentReview: boolean;
  ratingBreakup: RatingBreakup;
  ratingHighlight: RatingHighlight;
  subConcepts: SubConcept[];
  ratingSummaryGI: HotelRatingSummary[];
  ratingText: string;
  bestReviewTitle: string;
  preferredOTA: boolean;
  extRating: ExtRating;
}

export interface Review {
  publishDate: string;
  travellerName: string;
  travellerImage: string;
  badgeUrl: string;
  reviewsWrittenInfo: string;
  title: string;
  rating: number;
  reviewText: string;
  id: string;
  images: Image[];
  travelType: string;
  roomType: string;
  expData: ExpData;
  responseToReview: ResponseToReview;
}

export interface Image {
  imgUrl: string;
  mmtTagList: string[];
}

export interface ExpData {
  header: string;
  poweredByText: string;
  logo: string;
}

export interface ResponseToReview {
  name: string;
  responseDate: string;
  repliedAgoText: string;
  responseText: string;
}

export interface RatingBreakup {
  '1': number;
  '2': number;
  '3': number;
  '4': number;
  '5': number;
}

export interface RatingHighlight {
  title: string;
  rating: number;
  text: string;
}

export interface SubConcept {
  sentiment: string;
  subConcept: string;
  relatedReviewCount: number;
  priorityScore: number;
  tagType: string;
  displayText: string;
  source: string;
}

export interface HotelRatingSummary {
  concept: string;
  displayText: string;
  value: number;
  reviewCount: number;
  show: boolean;
  iconUrl: string;
}

export interface ExtRating {
  header: string;
  descriptionTitle: string;
  descriptionInfo: string;
}
